module.exports = __webpack_public_path__ + "img/Immagine-BarraNav-v2.10d12f0c.jpg";